import React, { PropsWithChildren } from 'react';
import { Provider, ErrorBoundary } from '@rollbar/react';
import type Rollbar from 'rollbar';
import ErrorView from '../views/ErrorView/ErrorView';

const RollbarProvider: React.FC<PropsWithChildren<{ instance?: Rollbar }>> = ({
  children,
  instance,
}) => {
  if (!instance) {
    return <>{children}</>;
  }

  return (
    <Provider instance={instance}>
      <ErrorBoundary fallbackUI={ErrorView}>{children}</ErrorBoundary>
    </Provider>
  );
};

export default RollbarProvider;
